export default ".txt-bold {\n  font-weight: bold;\n}\n\n.txt-link {\n  text-decoration: underline;\n  color: blue;\n}";